/**
 * @ngdoc constant
 * @name TRACKING_EVENTS
 * @description
 * The tracking events.
 *
 * @memberof common
 * @type {Object}
 * @property {Object} navigation                   The navigation tracking events.
 * @property {String} navigation.clickLogin        When the login gets clicked.
 * @property {String} navigation.clickHome         When the home menu item gets clicked.
 * @property {String} navigation.clickUpload       When the upload menu item gets clicked.
 * @property {String} navigation.clickCommunity    When the community menu item gets clicked.
 * @property {String} navigation.clickMe           When the me menu item gets clicked.
 * @property {String} navigation.clickCampaign     When the campaign item gets clicked.
 * @property {Object} campaign                     The campaign section tracking events.
 * @property {String} campaign.clickUpload         When the upload button gets clicked.
 * @property {String} campaign.clickPhoto          When the photo gets clicked.
 * @property {String} campaign.clickGuidelines     When the guidelines gets clicked.
 * @property {Object} upload                       The upload section tracking events.
 * @property {String} upload.clickAddMore          When the add more button gets clicked.
 * @property {String} upload.clickDelete           When the delete button gets clicked.
 * @property {String} upload.clickCampaign         When the campaign selector gets clicked.
 * @property {String} upload.clickFinish           When the finish button gets clicked.
 * @property {Object} me                           The me section tracking events.
 * @property {String} me.clickPhoto                When the photo gets clicked.
 * @property {String} me.clickLogout               When the logout button gets clicked.
 * @property {Object} community                    The community section tracking events.
 * @property {String} community.clickMostRecent    When the most recent menu gets clicked.
 * @property {String} community.clickByCampaign    When the by campaign menu gets clicked.
 * @property {String} community.clickCampaignName  When the campaign name gets clicked.
 * @property {String} community.clickUpload        When the upload button gets clicked.
 * @property {String} community.clickPhoto         When the photo gets clicked.
 * @property {Object} photo                        The photo section tracking events.
 * @property {String} photo.clickClose             When the close button gets clicked.
 */

const trackingEvents = {
  navigation: {
    clickLogin: 'Navigation|Click_login',
    clickHome: 'Navigation|Click_home',
    clickUpload: 'Navigation|Click_upload',
    clickCommunity: 'Navigation|Click_community',
    clickMe: 'Navigation|Click_me',
    clickCampaign: 'Navigation|Click_campaign',
  },
  campaign: {
    clickUpload: 'Campaign|Click_upload',
    clickPhoto: 'Campaign|Click_photo',
    clickGuidelines: 'Campaign|Click_guidelines',
  },
  upload: {
    clickAddMore: 'Upload|Click_add_more_photos',
    clickDelete: 'Upload|Click_delete',
    clickCampaign: 'Upload|Click_choose_campaign',
    clickFinish: 'Upload|Click_finish',
  },
  me: {
    clickPhoto: 'Me|Click_photo',
    clickLogout: 'Me|Click_logout',
  },
  community: {
    clickMostRecent: 'Community|Click_most_recent',
    clickByCampaign: 'Community|Click_by_campaign',
    clickCampaignName: 'Community|Click_campaign_name',
    clickUpload: 'Community|Click_upload',
    clickPhoto: 'Community|Click_photo',
  },
  photo: {
    clickClose: 'Photo|Click_close',
  },
};

export default trackingEvents;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/constants/trackingEvents.js